import AssignmentsCard from './AssignmentsCard';
export default AssignmentsCard;
